<script lang="ts">

    import {onMount} from "svelte";
    import {getLocalStorageItem, getQuestionnaire, getQuestionnaireProgress, triggerEvaluation} from "../utility.js";
    import PageBox from "../layouts/PageBox.svelte";
    import ContentBox from "../layouts/ContentBox.svelte";
    import {push} from "svelte-spa-router";
    import Button from "../ui_elements/Button.svelte";
    import CategoryProgressBar from "./questionnaire-components/CategoryProgressBar.svelte";
    import Spinner from "../misc/Spinner.svelte";
    import { CategoryModel } from "../models/CategoryModel";
    import {ProgressUtil} from "../progress";

    let categories: CategoryModel[] = [];
    let highestAvailableCategory = 0;
    let answers: any;

    let fetching: boolean = true;
    let done: boolean = false;

    onMount(async () => {
        const data = await getQuestionnaire();
        categories = data.categories.filter((a: CategoryModel) => {
            return a.category_name != "Feedback"
        });

        let isDone = true;
        for (let category of categories) {
            category.progress = ProgressUtil.getProgressByCategory(category, answers);
            if (category.progress.total != category.progress.current) isDone = false;
        }

        done = isDone;

        const data2 = await getQuestionnaireProgress();
        console.log(data2);
        highestAvailableCategory = data2.highest_available_category;

        answers = getLocalStorageItem('questionnaireAnswers');

        fetching = false;
    });

    function submitQuestionnaire() {
        triggerEvaluation();
        push('/answers');
    }

    function getCategoryStatus(category: CategoryModel) {
        if (category.category_id > highestAvailableCategory) {
            return "Nicht verfügbar"
        }
        if (category.progress.current == 0) {
            return "Nicht begonnen"
        }
        if (category.progress.current < category.progress.total) {
            return "In Arbeit"
        }
        return "Abgeschlossen"
    }

    function getButtonText(category: CategoryModel) {
      if (category.category_id > highestAvailableCategory) {
        return "Starten"
      }
      if (category.progress.current == 0) {
        return "Starten"
      }
      if (category.progress.current < category.progress.total) {
        return "Fortsetzen"
      }
      return "icon_edit"
    }

    function getButtonType(category: CategoryModel) {
      if (category.category_id > highestAvailableCategory) {
        return "default"
      }
      if (category.progress.current == 0) {
        return "submit"
      }
      if (category.progress.current < category.progress.total) {
        return "submit"
      }
      return "default"
    }

</script>

<PageBox pageTitle="Kategorien" description="Der Fragebogen ist in folgende Kategorien unterteilt.">
{#if !categories || fetching}
    <ContentBox>
        <Spinner/>
        <p class="text-center">Lade Übersicht...</p>
    </ContentBox>
{:else}
    {#each categories as category}
        <ContentBox className="{category.category_id > highestAvailableCategory ? 'grayscale brightness-75 pointer-events-none' : ''}">
            <div>
                <div class="inline-block">
                    <div class="text-secondary-text font-bold text-lg">{category.category_name}</div>
                    <p>{category.description}</p>
                </div>
                    <span class="block text-right float-right">{getCategoryStatus(category)}</span>
            </div>
            <div class="flex items-center justify-center gap-2">
                <div class="grow">
                    <CategoryProgressBar category="{category}" answers="{answers}"/>
                </div>
                <Button on:click={() => push("/questionnaire/" + category.category_id + "/0/")} variant="{getButtonType(category)}" size="{getButtonText(category) === 'icon_edit' ? 'icon' : 'default'}" className="inline-flex">
                    {#if getButtonText(category) === "icon_edit"}
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-pencil"><path d="M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z"/><path d="m15 5 4 4"/></svg>
                    {:else}
                        {getButtonText(category)}
                    {/if}
                </Button>
            </div>
        </ContentBox>
    {/each}
    <ContentBox>
        <p>Schließe alle Kategorien ab um den Fragebogen absenden zu können!</p>
        <Button on:click={submitQuestionnaire} className="ml-auto" variant="submit" disabled="{!done}">Fragebogen auswerten</Button>
    </ContentBox>
{/if}
</PageBox>
